
import flatpickr from 'flatpickr';
import { Finnish } from 'flatpickr/dist/l10n/fi';
import SVGIcons from './svgicons';
import delegateListener from './delegate-listener';

const svgIcons = new SVGIcons();

const ISODatePattern = '\d{4}-\d{2}-\d{2}';
const flatpickrDatePattern = '^(?:(?:31(\\/|-|\\.)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-|\\.)(?:0?[13-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-|\\.)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-|\\.)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$';

const flatpickrSettings = {
  allowInput: true,
  altInput: true,
  altFormat: 'd.m.Y',
  locale: Finnish,
  position: 'below right',
  nextArrow: svgIcons('caret-right'),
  prevArrow: svgIcons('caret-left'),
  onReady: (_, __, instance) => applyPattern(instance, flatpickrDatePattern)
};

function applyPattern(instance, pattern) {
  // Apply validation pattern to datepickr's input field, if available
  if(instance.element.pattern) instance.altInput.pattern = pattern;
  if(instance.element.required) instance.altInput.required = 'required';
}

function handleFocusOut(event) {
  const fpInput = event.delegateTarget;
  const { value } = fpInput;
  const dateInput = fpInput.parentElement.querySelector('.flatpickr-input');
  const instance = dateInput._flatpickr;
  if(instance && value) {
    const { altFormat } = instance.config;
    const parsedDate = instance.parseDate(value, altFormat);
    const formattedDate = instance.formatDate(parsedDate, altFormat);
    if(value === formattedDate) {
      fpInput.classList.remove('invalid');
      dateInput.value = formattedDate;
      instance.setDate(value, true, altFormat);
    } else {
      fpInput.classList.add('invalid');
      fpInput.focus();
    }
  }
}

class DateInputs {
  constructor(options = {}) {
    const defaults = {
      inputSelector: '[type="date"]',
      flatpickrSelector: '.flatpickr-input',
      patternDate: ISODatePattern
    };
    Object.assign(this, defaults, options);
  }

  init() {
    if(document.querySelector(this.inputSelector)) {
      flatpickr(this.inputSelector, flatpickrSettings);

      document.body.addEventListener(
        'focusout',
        delegateListener(this.flatpickrSelector, handleFocusOut)
      );
    }
  }
}

export default DateInputs
export {
  DateInputs,
  flatpickrSettings,
  flatpickrDatePattern,
  ISODatePattern,
  applyPattern,
  handleFocusOut
}
